import classNames from 'classnames';
import { Button } from 'antd';
import type { FC, MouseEvent } from 'react';
import { SelectDropdown } from '@shared/assets/icons/components';
import { Text } from '@shared/ui/antd';
import type { PrimaryNavigationItem } from '../../types';
import styles from '../../sidebar-primary-navigation.module.scss';

interface NavigationItemProps {
  item: PrimaryNavigationItem;
  isActive: boolean;
  isDisabled: boolean;
  hasDropdown: boolean;
  isDropdownOpen: boolean;
  onClick: () => void;
  onDropdownToggle?: () => void;
}

export const NavigationItem: FC<NavigationItemProps> = ({
  item,
  isActive,
  isDisabled,
  hasDropdown,
  isDropdownOpen,
  onClick,
  onDropdownToggle,
}) => {
  const handleButtonClick = hasDropdown ? (onDropdownToggle ?? onClick) : onClick;

  const handleDropdownClick = (event: MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    onDropdownToggle?.();
  };

  return (
    <Button
      disabled={isDisabled}
      onClick={handleButtonClick}
      className={classNames(styles.sidebarPrimaryNav__navItem, {
        [styles['sidebarPrimaryNav__navItem--active']]: isActive,
      })}
      variant="text"
    >
      <span className={styles.sidebarPrimaryNav__navItemContent}>
        <span className={styles.sidebarPrimaryNav__navItemIcon}>{item.icon}</span>
        <Text className={styles.sidebarPrimaryNav__navItemText} fontWeight={400} variant="sm">
          {item.heading}
        </Text>
        {hasDropdown && (
          <span className={styles.sidebarPrimaryNav__dropdownToggle} onClick={handleDropdownClick}>
            <SelectDropdown
              className={classNames(styles.sidebarPrimaryNav__dropdownIcon, {
                [styles['sidebarPrimaryNav__dropdownIcon--active']]: isDropdownOpen,
              })}
            />
          </span>
        )}
      </span>
    </Button>
  );
};
